import styled from 'styled-components';

const TooltipButton = styled.button`
    background-color: transparent;
    outline: none;
    border: 0px;
    text-align: left;
    padding: 10px 17px;
    font-size: 16px;
    font-weight: 600;
    color: #26292D;
    -webkit-transition: background-color 500ms linear;
    -ms-transition: background-color 500ms linear;
    transition: background-color 500ms linear;
    &:hover {
        background-color: #F0F3F5;
    }
    &:focus {
        outline: 0;
    }
`

export default TooltipButton;